export const BorderWidth = {
  none: '0px',
  sm: '1px',
  md: '2px',
  lg: '3px',
  xl: '4px',
} as const;

export const BorderStyle = {
  solid: 'solid',
  dashed: 'dashed',
} as const;

export type BorderWidthTokenType = keyof typeof BorderWidth;
export type BorderStyleTokenType = keyof typeof BorderStyle;
